<button [name]="name" class="toggle-button hinted" (click)="toggle()"
        [ngClass]="{'toggled': value && !noToggle, 'no-toggle': noToggle, 'small': small, 'show': show }" [disabled]="disabled">
  <fa [name]="'fa fa-'+icon"></fa>
  <div class="hint" *ngIf="hint">{{hint}}</div>
</button>
